import React from 'react'

import { Typography, Button, Box, Link } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

import { useAppState } from '../../components/root/contexts/AppContext'
import { getPathFromCulture } from '../../utils/LocalizationHelpers'

export const ErrorPage: React.FC = () => {
  const { culture } = useAppState()
  const { t } = useLocalizations()
  const pathFromCulture = getPathFromCulture(culture)

  return (
    <Box py={11} mx={3} align="center" data-testid="error-page-content">
      <Typography fontSkin="title-section" textAlign="center" py={5}>
        {t('error-page.error-heading')}
      </Typography>
      <Typography fontSize="large" textAlign="center" py={5}>
        {t('error-page.error-subtitle')}
      </Typography>
      <Button
        skin="primary"
        my={7}
        render={(props) => (
          <Link href={`${pathFromCulture}/`} className={props.className}>
            {props.children}
          </Link>
        )}
      >
        {t('error-page.homepage-cta-text')}
      </Button>
    </Box>
  )
}
